// A19.14 GDPR data-subject-request tracking — module-local data layer. REAL
// backend (/admin/gdpr-requests). Tracking only — no auto-erasure/export.
import { api } from '@/lib/api'

export interface GDPRRequest {
  id: number
  subject: string
  kind: string
  status: string
  reason: string
  resolution: string
  due_at: string
  completed_at: string | null
  created_at: string
  overdue: boolean
}

export const fetchRequests = (status = '', s?: AbortSignal) =>
  api.get<{ requests: GDPRRequest[] }>('/admin/gdpr-requests', { query: status ? { status } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.requests ?? [])
export const createRequest = (body: { subject_user_id?: number; subject_ref: string; kind: string; reason: string }) =>
  api.post<{ id: number }>('/admin/gdpr-requests', body)
export const updateStatus = (id: number, status: string, resolution: string) =>
  api.post(`/admin/gdpr-requests/${id}/status`, { status, resolution })
export const deleteRequest = (id: number) => api.del(`/admin/gdpr-requests/${id}`)

export const KINDS = [
  { key: 'access', label: 'Доступ' },
  { key: 'export', label: 'Экспорт' },
  { key: 'erasure', label: 'Удаление' },
  { key: 'rectification', label: 'Исправление' },
  { key: 'objection', label: 'Возражение' },
] as const

export const STATUSES = [
  { key: 'open', label: 'Открыт', pill: 'bg-warning/10 text-warning' },
  { key: 'in_progress', label: 'В работе', pill: 'bg-accent/10 text-accent' },
  { key: 'completed', label: 'Выполнен', pill: 'bg-success/10 text-success' },
  { key: 'rejected', label: 'Отклонён', pill: 'bg-surface-3 text-tertiary' },
] as const

export function kindLabel(k: string) {
  return KINDS.find((x) => x.key === k)?.label ?? k
}
export function statusMeta(s: string) {
  return STATUSES.find((x) => x.key === s) ?? STATUSES[0]
}

export const GD_STR = {
  title: 'GDPR запросы (DSAR)',
  desc: 'Запросы субъектов данных — учёт и срок (30 дней). Только отслеживание, без авто-удаления',
  create: 'Новый запрос',
  subjectUser: 'ID пользователя (опц.)',
  subjectRef: 'Email/телефон субъекта',
  kind: 'Тип',
  reason: 'Причина / детали',
  resolution: 'Решение',
  add: 'Создать',
  due: 'Срок',
  overdue: 'Просрочен',
  markInProgress: 'В работу',
  complete: 'Выполнить',
  reject: 'Отклонить',
  delete: 'Удалить',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет запросов',
  all: 'Все',
  subject: 'Субъект',
} as const
